import { useSyncExternalStore } from "react";

const STORAGE_KEY = "daynav.gdpr";
const CONSENT_EVENT = "daynav:consent";

export type CookieConsent = {
  decision: "accept" | "decline";
  at: string;
};

export function setConsent(decision: "accept" | "decline"): void {
  try {
    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({ decision, at: new Date().toISOString() }),
    );
  } catch {
    // quota / privacy-mode failures
  }
  window.dispatchEvent(new Event(CONSENT_EVENT));
}

export function clearConsent(): void {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    // quota / privacy-mode failures
  }
  window.dispatchEvent(new Event(CONSENT_EVENT));
}

export function getConsent(): CookieConsent | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (parsed.decision === "accept" || parsed.decision === "decline") {
      return parsed as CookieConsent;
    }
    return null;
  } catch {
    return null;
  }
}

function subscribe(cb: () => void): () => void {
  window.addEventListener(CONSENT_EVENT, cb);
  return () => window.removeEventListener(CONSENT_EVENT, cb);
}

function getSnapshot(): boolean {
  return getConsent()?.decision === "accept";
}

export function useConsent(): boolean {
  return useSyncExternalStore(subscribe, getSnapshot);
}

export function isExternalUrl(url: string | null | undefined): boolean {
  if (!url) return false;
  return url.startsWith("http://") || url.startsWith("https://");
}
